import type { BookingMode } from "@/data/certificateBookingActions";

type ConfirmationFormModes = {
  digital?: string;
  onsite?: string;
};

const form = (q: string) => `https://intygslakaren.hlthy.se/landingform?q=${q}`;

const hogreBehorighetForms: ConfirmationFormModes = {
  digital: form("SzcYBrs3"),
  onsite: form("xUtBul_q"),
};

/** Post-booking Healthy landing forms by certificate slug + visit mode. */
export const CONFIRMATION_FORM_BY_SLUG: Record<string, ConfirmationFormModes> = {
  "afs-handintensivt": { onsite: form("ArtH6E3r") },
  nattarbete: { onsite: form("929ZfPOu") },
  "afs-vibrationer": { onsite: form("n0xqvSc2") },
  "au-pair": {
    digital: form("6lHIEXH9"),
    onsite: form("KtFBlnsg"),
  },
  fallskarmsintyg: { onsite: form("qFgd0BEX") },
  "fit-for-fly": {
    digital: form("p894cIwm"),
    onsite: form("li2A8_e3"),
  },
  forstadagsintyg: {
    digital: form("g0sa2lo2"),
    onsite: form("b6IAVPRI"),
  },
  "hogre-behorighet": hogreBehorighetForms,
  "c-ce": hogreBehorighetForms,
  "d-de": hogreBehorighetForms,
  "buss-lastbil": hogreBehorighetForms,
  taxi: hogreBehorighetForms,
  "installd-resa": {
    digital: form("hZh0ASli"),
    onsite: form("AN-nGPEB"),
  },
  alkolas: {
    digital: form("Oq7qMb9K"),
    onsite: form("hhxakTwY"),
  },
  "korkort-diabetes": {
    digital: form("rRD2VkWh"),
    onsite: form("tsrpcgqN"),
  },
  "droger-alkohol": {
    digital: form("YloFLDuk"),
    onsite: form("9C6ub1qV"),
  },
  "korkort-hjarta": {
    digital: form("Pfa8fa7W"),
    onsite: form("ViElUtQi"),
  },
  utlandsstudier: {
    digital: form("8itHVetj"),
    onsite: form("bJUZ9ZgL"),
  },
  invaliditetsintyg: { onsite: form("3Mg2TiZw") },
  "reseintyg-gravid": {
    digital: form("i50OmXQJ"),
    onsite: form("sEJECDeA"),
  },
  sjofolksintyg: { onsite: form("MqF5aIUx") },
  "intyg-forsakring": { onsite: form("BMR4igws") },
  tavlingsintyg: {
    digital: form("MdgSYG4t"),
    onsite: form("l3wsCyWW"),
  },
};

export const getConfirmationFormUrl = (
  slug: string | null | undefined,
  mode: BookingMode | null | undefined,
): string | null => {
  if (!slug) return null;
  const forms = CONFIRMATION_FORM_BY_SLUG[slug];
  if (!forms) return null;

  if (mode === "digital") return forms.digital ?? forms.onsite ?? null;
  if (mode === "onsite") return forms.onsite ?? forms.digital ?? null;

  // No mode: only return a form when the certificate has a single destination.
  if (forms.digital && forms.onsite) return null;
  return forms.digital ?? forms.onsite ?? null;
};
